import { render, staticRenderFns } from "./MapObjectControls.vue?vue&type=template&id=495056b8&scoped=true&"
import script from "./MapObjectControls.vue?vue&type=script&lang=ts&"
export * from "./MapObjectControls.vue?vue&type=script&lang=ts&"
import style0 from "./MapObjectControls.vue?vue&type=style&index=0&id=495056b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495056b8",
  null
  
)

export default component.exports